import { ElementRef } from '@angular/core';

function readElementHeight(element: HTMLElement): number {
  return Math.ceil(element.getBoundingClientRect().height);
}

export function observeElementHeight(
  elementRef: ElementRef<HTMLElement> | undefined,
  onHeightChange: (height: number) => void,
): () => void {
  if (!elementRef) {
    onHeightChange(0);
    return () => undefined;
  }

  const element = elementRef.nativeElement;
  const emitHeight = () => onHeightChange(readElementHeight(element));

  emitHeight();

  if (typeof ResizeObserver === 'undefined') {
    return () => undefined;
  }

  const observer = new ResizeObserver(() => {
    emitHeight();
  });

  observer.observe(element);

  return () => {
    observer.disconnect();
  };
}
